import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminAuth } from './AuthProvider';

const ProtectedRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
    const { isAuthenticated } = useAdminAuth();
    if (!isAuthenticated) return <Navigate to="/admin/login" replace />;
    return children;
};

export default ProtectedRoute;
